import React from "react";
import styles from "../styles/habitaciones.module.css";

export default function HabitacionItem({
    habitacion,
    open,
    onToggle,
    onEdit,
    onDelete,
}) {
    const h = habitacion;
    const resumen = h.disponible ? "Disponible" : "No disponible";

    return (
        <div
            className={`${styles["item-card"]} ${styles.accordion} ${open ? styles.open : ""}`}
        >
            <button
                type="button"
                className={styles["accordion-header"]}
                onClick={() => onToggle(h.id)}
                aria-expanded={open}
                aria-controls={`hab-body-${h.id}`}
            >
                <div className={styles["accordion-title"]}>
                    <strong>{h.nombre || `Habitación #${h.id}`}</strong>
                    <span className={styles.muted}>— {resumen}</span>
                </div>
                <span className={styles.chevron} aria-hidden>▾</span>
            </button>

            <div id={`hab-body-${h.id}`} className={styles["accordion-body"]}>
                <div className={styles["item-row"]}>
                    <div className={styles["grid-3"]}>
                        <div className={styles.field}>
                            <label className={styles.label}>Descripción</label>
                            <div className={styles.muted}>{h.descripcion || "—"}</div>
                        </div>
                        <div className={styles.field}>
                            <label className={styles.label}>Comentarios</label>
                            <div className={styles.muted}>{h.comentarios || "—"}</div>
                        </div>
                        <div className={styles.field}>
                            <label className={styles.label}>Disponibilidad</label>
                            <span className={`${styles.pill} ${h.disponible ? "" : styles.danger}`}>
                                {h.disponible ? "Disponible" : "No disponible"}
                            </span>
                        </div>
                    </div>

                    <div className={styles["item-actions"]}>
                        <button className={styles.btn} type="button" onClick={() => onEdit(h)}>
                            Editar
                        </button>
                        <button
                            className={`${styles.btn} ${styles.danger}`}
                            type="button"
                            onClick={() => onDelete(h)}
                        >
                            Eliminar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
